// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1HZ_i","notes":"Notes_notes__1ZG7S","note":"Notes_note__TLa-p","markdown":"Notes_markdown__2uQaa"};